'use client';

import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useSessionKeepAlive } from '@/hooks/useSessionKeepAlive';

const RSC_REFRESH_THROTTLE_MS = 30 * 1000;

export function SessionKeepAlive() {
  useSessionKeepAlive();
  const router = useRouter();
  const lastRscRefreshRef = useRef<number>(Date.now());

  useEffect(() => {
    const maybeRefreshRsc = () => {
      const now = Date.now();
      if (now - lastRscRefreshRef.current < RSC_REFRESH_THROTTLE_MS) return;
      lastRscRefreshRef.current = now;
      router.refresh();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') maybeRefreshRsc();
    };
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) maybeRefreshRsc();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pageshow', handlePageShow);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [router]);

  return null;
}
